<template>
  <div class="orderTitle">
    <div class="leftTitle">
      <div style="font-size: 24px; color: #0099ff">点餐</div>
      <div>桌号:{{userdata.mealTableNum}}</div>
      <div>单号:{{userdata.orderNum}}</div>
      <div>人数:{{userdata.peopleCount}}</div>
      <div>菜品数量:{{num}}</div>
      <div>已点金额:{{totalPrice.toFixed(2)}}</div>
      <div>开单时间:{{userdata.createDate}}</div>
      <div>操作员:{{userdata.userName}}</div>
    </div>
    <div class="rightOperation">
      <div @click="refuned">
        <i class="el-icon-refresh"></i>
        <!-- <span>刷新</span> -->
      </div>
      <div @click="goback">
        <i class="el-icon-back"></i>
        <!-- <span>返回</span> -->
      </div>
    </div>
  </div>
</template>
 
<script>
export default {
  data() {
    return {
      userdata: {},
      num: 0,
      totalPrice: 0,
      tableList: [],
      orderStatus: 0
    }
  },
  created() {
    this.userdata = JSON.parse(localStorage.getItem('openTaiUser'))
  },
  updated() {

  },
  watch: {
    orderStatus(val) {
   
      this.$bus.on("status", value => {
        val = value
        console.log(val);
        let num = 0;
        let total = 0;
        this.tableList.forEach(v => {
          num += v.number
          total += v.unit_price2 * v.number
          this.num = num
          this.unit_price2 = total
        })
      })
    },
    tableList(val) {
      console.log(val);
      let num = 0;
      let total = 0;
      val.forEach(v => {
        num += v.number
        total += v.unit_price2 * v.number
        this.num = num
        this.unit_price2 = total
      })
    }
  },
  mounted() {

    this.$bus.$on("bload", v => {
    this.num += v.quantity ? v.quantity * 1 : 1
      let price = v.is_price_show1 ? v.unit_price1 : v.unit_price2

      this.totalPrice += price * (v.quantity ? v.quantity : 1)
    });

    this.$bus.$on("addNum", value => {
      ++this.num
      this.totalPrice = this.totalPrice + value.totalPrice

    });
    this.$bus.$on("number", (number, num) => {
      // console.log('status', value);
      this.num = number
      this.totalPrice = num * 1
    });
    this.$bus.$on("totalPrice", value => {
      // console.log('status', value);

      this.totalPrice = value
    });

    this.$bus.$on("reduceNumorderList", (value, n) => {
      --this.num
 
      this.totalPrice = this.totalPrice - value.price
    });
    this.$bus.$on("allCanel", value => {
     this.num=0
 
      this.totalPrice = 0
    });
  
    this.$bus.$on("removeList", value => {
      this.num=this.num-value.quantity

      this.totalPrice = this.totalPrice - value.totalPrice
    });

  },
  methods: {
    //刷新页面
    refuned() {
      this.$router.go(0)
    },
    goback() {
      this.$bus.$emit("goback", 1)
    }
  }

};
</script>

<style lang="scss" scoped>
.orderTitle {
  width: 100%;
  height: 100%;
  display: flex;
  background: #fff;
  .leftTitle {
    padding: 0 30px;
    width: 95%;
    height: 100%;
    display: flex;
    align-items: center;
    div {
      color: #666;
      margin-right: 25px;
      font-size: 18px;
    }
  }
  .rightOperation {
    width: 20%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #666;
    i {
      font-size: 30px;
    }
    div {
      width: 50px;
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 20px;
      margin: 0 33px;
      cursor: pointer;
      span {
        margin-top: 10px;
      }
    }
  }
}
</style>